import type { LevelModel } from 'shared/domain/level/types/model';
import type { ProcessType } from 'shared/domain/process/types/model';
import type { SiteModel } from 'shared/domain/site/types/model';

/** The entities an issue refers to and cannot be shown without. */
export interface IssueReferences {
  site: SiteModel;
  level: LevelModel;
  process: ProcessType;
}

export enum IssueReferenceName {
  SITE = 'site',
  LEVEL = 'level',
  PROCESS = 'process',
}
